import { IconLoader, Table } from '@ui/src';
import StepPartBlock from '../step-part-block';
import { agreementsListColumns } from './variables/agreements';
import useAgreements from './hooks/use-agreements';
import { AgreementsTypes } from './types';
import { ApplicationAgreement } from '../../../../hoc/new-application/types';

import commonStyles from '../styles.module.css';
import cn from './styles.module.css';

const ApplicationAgreements = ({
  zIndex,
  list,
  errors,
  agreementsIsLoading,
  activePermissions,
  agreementsErrorsList,
}: AgreementsTypes) => {
  const { formattedData, sort, filters, onSortChange, onFilterChange } =
    useAgreements({
      list: list as ApplicationAgreement[],
      activePermissions,
    });

  return (
    <div className={commonStyles.stepBlockWrapper} style={{ zIndex }}>
      <div className={commonStyles.stepBlockContent}>
        <StepPartBlock title="Agreements" zIndex={9}>
          <div className={cn.agreementsTableWrapper} id="agreementIds">
            {errors?.agreements?.message && (
              <div className={cn.agreementsError}>
                {errors?.agreements?.message}
              </div>
            )}
            {agreementsIsLoading && (
              <div className={cn.agreementsLoader}>
                <IconLoader />
              </div>
            )}
            {!agreementsIsLoading && (
              <Table
                columns={agreementsListColumns}
                data={formattedData || []}
                columnsLabels={{}}
                sort={sort}
                error={agreementsErrorsList}
                filters={filters}
                onSort={onSortChange}
                onFilterChange={onFilterChange}
                clickable
              />
            )}
          </div>
        </StepPartBlock>
      </div>
    </div>
  );
};

export default ApplicationAgreements;
